<template>
    <div class="wrapperEmployeeWork" v-if="isAuthenticated">
        <vue-loader :active="loader.status" :message="loader.message"></vue-loader>
        <div class="container">
            <div class="card">

                <div class="card-header">
                    <div class="card-title">
                        <div class="card-label" v-if="works && works.length > 0">Работы</div>
                        <div class="card-label" v-if="!works || works.length == 0">Для Вас нет работ</div>
                    </div>
                    <button class="btn btn-primary btn-sm btnResetWorks" @click="getUserWorks()"><i class="fas fa-sync-alt"></i></button>
                </div>

                <div class="card-body">

                    <div class="containerWorks">
                    <TransitionGroup name="slide-right" >
                        <div v-for="work, index in worksList" class="card blockWork" :class="{'completed': work.status == 'completed', 'working': work.status == 'working', 'suspended': work.status == 'suspended'}" :index="index" :key="work.id">

                            <div class="ribbon bg-success" style="top: -3px; left: -8px;" v-if="work.order.status_priority"><i class="fa fa-star text-white"></i></div>

                            <div class="card-header">
                                <div class="card-title">
                                    <div class="card-label">
                                        Заказ #{{ work.order.number }}: "{{ work.order.name }}" <small>[o-{{ work.order.id }} / w-{{ work.id }}]</small>
                                    </div>
                                </div>
                                <!-- <textarea style="width: 100%; height: 400px; margin: 40px 0;">{{ work.production_work.production_subs_works.length }}</textarea> -->
                                <div class="card-info">
                                    <div class="btn btn-primary btn-sm" @click="setSuccessWorkingWork(work.id, index)" v-if="work.status != 'working' && work.status != 'suspended' && work.status != 'completed'">Начать</div>
                                    <div class="btn btn-success btn-sm" @click="setSuccessWorkingWork(work.id, index)" v-if="work.status == 'suspended'">Продолжить</div>
                                    <div class="btn btn-danger btn-sm" @click="setSuccessSuspendedWork(work.id, index)" v-if="work.status == 'working'">Стоп</div>
                                    <div class="btn btn-success btn-sm" @click="setSuccessCompletedWork(work.id, index)" v-if="work.status == 'working'">Сделал</div>
                                    <div class="btn btn-primary btn-sm" @click="removeWork(index)" v-if="work.status == 'completed'">X</div>
                                    <div 
                                        class="drop-down drop-down-warning drop-down-sm" 
                                        :class="{ active: work.isSuspendActive }" 
                                        v-if="work.production_work.production_subs_works && work.production_work.production_subs_works.length > 0 && work.status == 'working'"
                                        @click="work.isSuspendActive = !(work.isSuspendActive??false)" 
                                        v-click-outside="function(){ work.isSuspendActive = false; }"
                                    >
                                        <div class="drop-label">Передать</div>
                                        <div class="drop-list">
                                            <div class="drop-item" v-for="workSub in work.production_work.production_subs_works" @click="setSuccessGiveWork(work.id, index, workSub.id, workSub.label)">{{ workSub.label }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card-body">

                                <div class="display-grid grid-gap-4 md:grid-cols-2 grid-cols-1">
                                    <div>
                                        <p>Работа: <strong>{{ work?.production_work?.label??work?.name??'---' }}</strong></p>
                                        <blockquote v-if="work.order.remark"><small>Комментарий заказа:</small><br>{{ work.order.remark }}</blockquote>
                                    </div>
                                    <div>
                                        <!-- <p>Цена: <strong>{{ formatNumber(work.price) }} р</strong></p> -->
                                        <p v-if="work.status_label">Статус работы: <strong>{{ work.status_label }}</strong></p>
                                        <p v-if="work.deadlines_minutes">Время на выполнение: <strong>{{ thousandFormat(work.deadlines_minutes) }}</strong></p>
                                        <p v-if="work.deadlines_minutes">Сроки: <strong>не известно</strong></p>
                                        <div v-if="work.prev_work">
                                            <hr>
                                            <p>prev work status: {{ work.prev_work.status }}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </TransitionGroup>
                    </div>

                </div>

            </div>
            <textarea style="width: 100%; height: 400px; margin: 40px 0;">{{ works }}</textarea>
        </div>
    </div>

    <Transition name="bounce-child">
    <div class="modalSuccessWorkAction modal" v-if="modalSuccessAccess.status">
        <div class="modal-content">
            <div class="modal-body">
                <div class="type">
                    <i class="fas fa-exclamation text-warning"></i>
                </div>
                <div class="label">{{ modalSuccessAccess.label }}</div>
                <div class="text" v-if="modalSuccessAccess.text">{{ modalSuccessAccess.text }}</div>
                <div class="form-group">
                    <textarea v-model="modalSuccessAccess.comment" placeholder="Комментарий"></textarea>
                </div>
                <div class="data">
                    <div class="display-grid grid-cols-2 grid-gap-3">
                        <button class="btn btn-danger" v-if="modalSuccessAccess.action == 'working'" @click="successAction()">Начать</button>
                        <button class="btn btn-danger" v-if="modalSuccessAccess.action == 'completed'" @click="successAction()">Окончить</button>
                        <button class="btn btn-danger" v-if="modalSuccessAccess.action == 'suspended'" @click="successAction()">Приостановить</button>
                        <button class="btn btn-danger" v-if="modalSuccessAccess.action == 'give'" @click="successAction()">Передать</button>
                        <button class="btn btn-primary" @click="abortSuccessAction()">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </Transition>

</template>

<script>
import Logout from '@/VueWorking/Pages/Logout.vue';

export default {
    name: 'EmployeeWorks',
    components: { Logout },
    data() {
        return {
            isAuthenticated: parseFloat(localStorage.authenticated),
            loader: {
                status: false,
                message: null,
            },
            modalSuccessAccess: {
                status: false,
                label: null,
                text: null,
                action: null,
                workId: null,
                workSubId: null,
                workIndex: null,
                comment: null,
            },
            user: null,
            works: null,
            timing: null,
        }
    },
    mounted(){
        // this.user = this.getUser();
        this.user = this.$store.state.user;
        this.getUserWorks();
        this.timing = setInterval(()=>{ this.updateUserWork() }, 10000)
    },
    computed: {
        loadNext: function(){ return this.notifications.length < this.countNotifications; },
        newNotifications: function(){
            let newN = 0;
            this.notifications.forEach(v => v.read == false ? newN++ : v);
            return newN;
        },
        worksList: function(){
            return this.works
                ? this.works.sort((a, b) => { return a.order - b.order;})
                : [];
        },
    },
    methods: {
        thousandFormat(value) {
            let val = parseFloat(value);
            let res = val + ' мин';
            if(val > 60){
                res = Math.trunc(val / 60);
                let resDecimal = val % 60;
                if(resDecimal > 0) res += '`' + resDecimal;
                res += ' ч';
            }
            return res;
        },
        formatNumber(value) {
            if (value === null || value === undefined || value === '') return '';
            
            // Преобразуем в число, если это строка
            const num = typeof value === 'string' 
                ? parseFloat(value.replace(/,/g, '.').replace(/\s+/g, '')) 
                : Number(value);
            
            // Проверяем, что это корректное число
            if (isNaN(num)) return value;
            
            // Форматируем число
            return num.toLocaleString('ru-RU', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                useGrouping: true
            }).replace(/\./g, ','); // Заменяем точку на запятую, если нужно
        },

        removeWork(index){
            this.works.splice(index, 1);
        },

        clearModalInputs(){
            this.modalSuccessAccess.label = null;
            this.modalSuccessAccess.text = null;
            this.modalSuccessAccess.action = null;
            this.modalSuccessAccess.workId = null;
            this.modalSuccessAccess.workSubId = null;
            this.modalSuccessAccess.workIndex = null;
            this.modalSuccessAccess.comment = null;
        },
        setSuccessWorkingWork(idWork, index){
            this.modalSuccessAccess.label = 'Подтверждение';
            this.modalSuccessAccess.text = 'Начинаем выполнять работу';
            this.modalSuccessAccess.action = 'working';
            this.modalSuccessAccess.workId = idWork;
            this.modalSuccessAccess.workIndex = index;
            this.modalSuccessAccess.status = true;
        },
        setSuccessSuspendedWork(idWork, index){
            this.modalSuccessAccess.label = 'Подтверждение';
            this.modalSuccessAccess.text = 'Остановить выполнение работы';
            this.modalSuccessAccess.action = 'suspended';
            this.modalSuccessAccess.workId = idWork;
            this.modalSuccessAccess.workIndex = index;
            this.modalSuccessAccess.status = true;
        },
        setSuccessCompletedWork(idWork, index){
            this.modalSuccessAccess.label = 'Подтверждение';
            this.modalSuccessAccess.text = 'Окончили выполнять работу';
            this.modalSuccessAccess.action = 'completed';
            this.modalSuccessAccess.workId = idWork;
            this.modalSuccessAccess.workIndex = index;
            this.modalSuccessAccess.status = true;
        },
        setSuccessGiveWork(idWork, index, workSubId, text = '---'){
            this.modalSuccessAccess.label = 'Передача';
            this.modalSuccessAccess.text = 'Передаем работу "' + text + '"';
            this.modalSuccessAccess.action = 'give';
            this.modalSuccessAccess.workId = idWork;
            this.modalSuccessAccess.workSubId = workSubId;
            this.modalSuccessAccess.workIndex = index;
            this.modalSuccessAccess.status = true;
        },
        abortSuccessAction(){
            this.clearModalInputs();
            this.modalSuccessAccess.status = false;
        },
        successAction(){
            if(this.modalSuccessAccess.status == false){
                window.$func.getAlert('error', 'Ошибка', 'Попытка осуществить без подтверждения');
                exit;
            }
            let idWork = this.modalSuccessAccess.workId;
            let idWorkSub = this.modalSuccessAccess.workSubId;
            let index = this.modalSuccessAccess.workIndex;
            let action = this.modalSuccessAccess.action;
            let comment = this.modalSuccessAccess.comment;
            if(index == null){
                window.$func.getAlert('error', 'Ошибка', 'Не определен индекс работы');
                exit;
            }
            if(idWork == null){
                window.$func.getAlert('error', 'Ошибка', 'Попытка определен уникальный ключ работы');
                exit;
            }
            if(action == null){
                window.$func.getAlert('error', 'Ошибка', 'Не определенно действие над работой');
                exit;
            }
            if(action == 'give' && idWorkSub == null){
                window.$func.getAlert('error', 'Ошибка', 'Не можем определить куда передаем');
                exit;
            }
            this.clearModalInputs();
            this.modalSuccessAccess.status = false;
            if(action == 'working'){
                this.setWorkingWork(idWork, index, comment);
            } else if(action == 'suspended'){
                this.setSuspendedWork(idWork, index, comment);
            } else if(action == 'completed'){
                this.setCompletedWork(idWork, index, comment);
            } else if(action == 'give'){
                this.setGiveWork(idWork, index, idWorkSub, comment);
            }
        },


        setWorkingWork(idWork, index, comment = ''){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Устанавливаем статус';
            axios.post('/web-api/order-works/' + idWork + '/set-working', 
                {comment: comment}, 
                { headers: { 'Content-Type': 'application/json' }}
            )
            .then(function(res){
                console.log('web-api/order-works/set-working');
                console.log(res.data);
                if(res.data.status == true){
                    _this.works[index].status = res.data.data.status;
                    _this.works[index].status_label = res.data.data.status_label??res.data.data.statusLabel??'изменен';
                } else {
                    window.$func.getAlert('error', 'Ошибка', res.data.message)
                }
            })
            .catch(function(error){
                console.log(error);
                _this.loader.status = false; _this.loader.message = null;
                window.$func.exceptionsHandler(error);
            })
            .then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },
        setSuspendedWork(idWork, index, comment = ''){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Устанавливаем статус';
            console.log(comment);
            axios.post('/web-api/order-works/' + idWork + '/set-suspended', 
                {comment: comment}, 
                { headers: { 'Content-Type': 'application/json' }}
            )
            .then(function(res){
                console.log('web-api/order-works/set-working');
                console.log(res.data);
                if(res.data.status == true){
                    _this.works[index].status = res.data.data.status;
                    _this.works[index].status_label = res.data.data.status_label??res.data.data.statusLabel??'изменен';
                } else {
                    window.$func.getAlert('error', 'Ошибка', res.data.message)
                }
            })
            .catch(function(error){
                console.log(error);
                _this.loader.status = false; _this.loader.message = null;
                window.$func.exceptionsHandler(error);
            })
            .then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },
        setCompletedWork(idWork, index, comment = ''){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Устанавливаем статус';
            axios.post('/web-api/order-works/' + idWork + '/set-completed',  
                {comment: comment}, 
                { headers: { 'Content-Type': 'application/json' }}
            )
            .then(function(res){
                console.log('web-api/order-works/set-completed');
                console.log(res.data);
                if(res.data.status == true){
                    _this.works[index].status = res.data.data.status;
                    _this.works[index].status_label = res.data.data.status_label??res.data.data.statusLabel??'изменен';
                    _this.removeWork(index);
                    window.$func.getAlert('success', 'Отлично', 'Работа отмечена выполненной')
                } else {
                    window.$func.getAlert('error', 'Ошибка', res.data.message)
                }
            })
            .catch(function(error){
                console.log(error);
                _this.loader.status = false; _this.loader.message = null;
                window.$func.exceptionsHandler(error);
            })
            .then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },
        setGiveWork(idWork, index, idWorkSub, comment = ''){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Выполняем запрос';
            axios.post('/web-api/order-works/' + idWork + '/give/' + idWorkSub, 
                {comment: comment}, 
                { headers: { 'Content-Type': 'application/json' }}
            )
            .then(function(res){
                console.log('web-api/order-works/give');
                console.log(res.data);
                if(res.data.status == true){
                    _this.works[index].status = res.data.data.orderWork.status??'suspended';
                    _this.works[index].status_label = res.data.data.status_label??res.data.data.statusLabel??'изменен';
                    _this.removeWork(index);
                    window.$func.getAlert('success', 'Отлично', 'Работа передана на утверждение передачи')
                } else {
                    window.$func.getAlert('error', 'Ошибка', res.data.message)
                }
            })
            .catch(function(error){
                console.log(error);
                _this.loader.status = false; _this.loader.message = null;
                window.$func.exceptionsHandler(error);
            })
            .then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },

        async loadUserWorks(){
            let _this = this;
            await axios.post('/web-api/orders/works', 
                { headers: { 'Content-Type': 'application/json' }}
            )
            .then(function(res){
                console.log('web-api/orders/works');
                console.log(res.data);
                _this.works = res.data.data;
            })
            .catch(function(error){
                console.log(error);
                _this.loader.status = false; _this.loader.message = null;
                window.$func.exceptionsHandler(error);
            });
        },

        async getUserWorks(){
            let _this = this;
            this.loader.status = true; this.loader.message = 'Подгружаем работы';
            // axios.post('/web-api/orders/works', 
            //     { headers: { 'Content-Type': 'application/json' }}
            // )
            // .then(function(res){
            //     console.log('web-api/orders/works');
            //     console.log(res.data);
            //     _this.works = res.data.data;
            // })
            // .catch(function(error){
            //     console.log(error);
            //     window.$func.exceptionsHandler(error);
            // })
            await this.loadUserWorks().then(() => {
                _this.loader.status = false; _this.loader.message = null;
            });
        },


        async updateUserWork(){
            console.log('update works');
            await this.loadUserWorks();
        },

    },
    beforeDestroy() {
        clearInterval(this.timing);
    }
}
</script>